import React, { useEffect, useState } from 'react';
import { IBreakdown, InsightsContentType, IOption } from  '@/interfaces/insightsp2';
import { likes, comments, contentViews, uniqueViews, competitionPosts, peopleThanked, ugc, fileDownloads, video, mp3, compliance, events, sharedPosts } from '@/data/breakdownColumns';

const BreakdownContent =  ({data, selectedBreak}: {data:any, selectedBreak:IBreakdown}) => {

    const [fields, setFields] = useState<IOption[]>([]);
    const [gridType, setGridType] = useState<string>("");

    useEffect(() => {

        switch (selectedBreak.contentType) {
            case InsightsContentType.Like:
               
                setFields(likes);  
                setGridType("four-col");
                return;
            case InsightsContentType.Comment:

                setFields(comments);
                setGridType("four-col");
                return;
            case InsightsContentType.View:

                setFields(contentViews);
                setGridType("four-col");
                return;
            
            case InsightsContentType.UniqueView:

                setFields(uniqueViews);
                setGridType("four-col");
                return

            case InsightsContentType.Competition:

                setFields(competitionPosts);
                setGridType("three-col");
                return

            case InsightsContentType.Recognition:

                setFields(peopleThanked);
                setGridType("two-col");
                return

            case InsightsContentType.Ugc:

                setFields(ugc);
                setGridType("two-col");
                return

            case InsightsContentType.File:

                setFields(fileDownloads);
                setGridType("three-col");
                return

            case InsightsContentType.Video:

                setFields(video);
                setGridType("three-col");
                return

            
            case InsightsContentType.Mp3:

                setFields(mp3);
                setGridType("three-col");
                return

            case InsightsContentType.Compliance:

                setFields(compliance);
                setGridType("three-col");
                return

            case InsightsContentType.Event:

                setFields(events);
                setGridType("three-col");
                return

            case InsightsContentType.Share:

                setFields(sharedPosts);
                setGridType("three-col");
                return

            default:
                
        }

    }, []);

    function link(item:any):string{
        if (item.hasOwnProperty("uri") && item["uri"] !== null){
            return item["uri"];
        }

        return "#"
    }

    return (
    
        <div className="breakdown-grid-container">
            <div className={`breakdown-grid breakdown-grid-header ${gridType}`}>
                {fields.map((item, idx) => {
                    return (
                        <div key={idx}>{item.label}</div>
                    )
                })}
            </div>

            <div className="col-container">
                <div className={`breakdown-grid breakdown-grid-col ${gridType}`}>
                    {data.map((item, idxData) => {

                       return(
                            fields.map((field, idxField) => {

                                const key = `${idxData}-${idxField}`;

                                // First
                                if (idxField === 0){
                                    return (
                                        <div className="title-col" key={key}>
                                            <a href={link(item)}>{item[field.value]}</a>
                                        </div>
                                    )
                                }

                                // Last
                                if (idxField+1 === fields.length){
                                    return (
                                        <div key={key} className="count">      
                                            {selectedBreak.label === "Likes" 
                                            ?   <img className="image" alt={selectedBreak.label} src="/Content/img/icons/thumb.png" /> 
                                            :   <img className="image" alt={selectedBreak.label} src={selectedBreak.image} /> }

                                            <span>{item[field.value]}</span>
                                        </div>
                                    )
                                }

                                // Default
                                return (
                                    <div key={key}>{item[field.value]}</div>
                                )
                            })
                       )
                    })}
                </div>
            </div>
        </div>

    );
};

export default BreakdownContent;